import { Forms } from '@/types/forms/formStatus'

export const contentTextLabel = (steps: Forms[]) => {
    const lastForm = steps?.find((form) => form.completed === false)

    return lastForm?.formName || ''
}
